var _effectorFileName = "/builds/gmini/front-ui-kit/src/Chip/Chip.styled.ts";
import styled from 'styled-components';
import { CircularProgress } from '../CircularProgress';
import { CrossCircle } from '../icons';
export const DeleteIcon = styled(CrossCircle)`
  width: 20px;
  min-width: 20px;
  height: 20px;
  min-height: 20px;
  cursor: pointer;

  & path {
    fill: #4c5ecf;
    transition: 0.2s ease-out;
  }
`;
export const LoadingIcon = styled(CircularProgress)`
  min-width: 16px;
  min-height: 16px;
`;
export const Container = styled.div`
  background: rgba(125, 177, 255, 0.5);
  border-radius: 20px;
  display: flex;
  gap: 0 8px;
  align-items: center;
  justify-content: center;
  padding: 4px 4px 4px 8px;
  width: fit-content;

  &:hover {
    ${DeleteIcon} {
      path {
        fill: #4658cf;
      }

      &:hover {
        path {
          fill: #4658cf;
        }
      }
    }
  }
`;
export const Label = styled.div`
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0.10000000149011612px;
  text-align: left;
  cursor: default;
  color: #4c5ecf;
`;